import { DataPoint, BarDataPoint } from 'ComponentLibrary/src/molecules/Chart/types'

function filterDataPointsWithUndefinedValue(data?: DataPoint[]) {
    return data?.filter((data): data is DataPoint => data.value !== undefined) || []
}

function filterBarDataPointsWithUndefinedValue(data?: BarDataPoint[]) {
    return data?.filter((data): data is BarDataPoint => data.value !== undefined) || []
}

export { filterDataPointsWithUndefinedValue, filterBarDataPointsWithUndefinedValue }
